exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "form {\r\n    width: calc(100% - 110px); \r\n    display: inline-block;\r\n}\r\ninput{\r\n    width: 70%;\r\n}\r\nselect{\r\n    width: 30%;\r\n}\r\ninput, select {\r\n    /*display: inline-block;*/\r\n    float: left;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/component/filter/filter.component.css
// module id = 654
// module chunks = 0